import { useEffect, useState } from "react";
import axios from "../../../libs/axios";
import toast from "react-hot-toast";
import moment from "moment";

const dateFormat = "YYYY-MM-DD";

const ScreenDates = () => {
  const [end_date, setEndDate] = useState("");

  useEffect(() => {
    const getDates = async () => {
      try {
        const res = await axios.get("/screen-dates");

        if (res.status !== 200) throw new Error("Can not get screen dates.");

        const dates = res.data;

        setEndDate(moment(dates?.end_date).format(dateFormat));
      } catch (err) {
        console.log(err);
      }
    };

    getDates();
  }, []);

  const handleForm = async (e) => {
    e.preventDefault();

    if (!end_date) return toast.error("დასრულების თარიღის ველი აუცილებელია!");

    try {
      const res = await axios.put("/screen-dates", {
        end_date,
      });

      if (res.status !== 200)
        return toast.error("სქრინების ატვირთვის ბოლო ვადა ვერ განახლდა.");

      toast.success("სქრინების ატვირთვის ბოლო ვადა განახლდა.");
    } catch (err) {
      console.log(err);
      toast.error(err.message);
    }
  };

  return (
    <div className="container mx-auto my-4 px-7">
      <div className="space-x-4 mb-4">
        <form onSubmit={(e) => handleForm(e)}>
          <div className="card bg-white shadow-md">
            <div className="px-8 py-4 border-b border-gray-200">
              <h1 className="card-title">სქრინების ბოლო ვადა</h1>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="mt-5">
                  <label htmlFor="end_date" className="w-full">
                    დასრულების თარიღი
                  </label>
                  <input
                    value={end_date}
                    onChange={(e) => setEndDate(e.target.value)}
                    min={moment(new Date()).format(dateFormat)}
                    type="date"
                    id="end_date"
                    className="w-full mt-2 px-3 py-2 border border-gray-300 rounded-md text-md text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  />
                </div>
                <div className="text-center mt-5">
                  <button
                    type="submit"
                    className="btn btn-primary px-6 shadow rounded-3"
                  >
                    <svg
                      width={16}
                      height={16}
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 448 512"
                    >
                      <path
                        fill="#D1DBFF"
                        d="M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-242.7c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32L64 32zm0 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L96 224c-17.7 0-32-14.3-32-32l0-64zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
                      />
                    </svg>
                    შენახვა
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ScreenDates;
